import { isEmpty } from 'lodash'
import { warning } from '@/utils/alert'

const prepareSave = address => {
  if (isEmpty(address.attachment.content)) {
    delete address.attachment
  }

  return address
}

export default {
  prepareEmail () {
    this.address.email = this.user.email
  },
  prepareSave,
  afterSave (address) {
    this.saved = true
  },

  setAddress (address) {
    this.address = {
      ...this.address,
      ...address
    }
  },
  beforeSave (address) {
    if (address.phones.length < 1) {
      warning('Adicione pelo menos um telefone.')
      return false
    }

    return true
  },
  addPhone () {
    const phone = {...this.phone}

    if (isEmpty(phone.number)) {
      warning('Você precisa informar o número com DDD antes de adicionar')
      return
    }

    if (phone.number.length < 10) {
      warning('Informe um telefone válido com DDD')
      return
    }

    if (phone.type === 'mobile' && phone.number.length < 11) {
      warning('Informe um celular válido com DDD')

      return
    }

    if (phone.type === 'mobile') {
      phone.exten = ''
    }

    this.phone.number = null
    this.phone.exten = null

    this.address.phones.push(phone)
  },
  doDeletePhone (phone) {
    const index = this.address.phones.indexOf(phone)
    this.address.phones.splice(index, 1)
  },
  afterCreated () {
    this.wasRaised = true
    this.show = true
  },
  afterUpdated () {
    this.beenUpdated = true
    this.show = true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/form/resources/methods.js